import { isValueOf } from "src/services/predicates";
import * as GQL from "./graphql";

export const isGqlOrderBy = isValueOf(GQL.order_by);
